import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
  Typography,
  Box,
  IconButton,
  Paper,
  Grid,
} from "@mui/material";
import TableN from "../../reusableComponents/components/generics/TableN";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchGuardian,
  fetchLatestActiveInsureePolicy,
  fetchPoliciesByInsuree,
  fetchVerificationHistory,
  insureeVerificationHf,
  printCareSheet,
} from "../../action";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { decodeId, formatDateFromISO } from "../../utils/helper";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const StyledRightsTypography = styled(Grid)(({ theme }) => ({
  display: "flex",
  marginTop: "-4.2rem",
  paddingLeft: ".9rem",
}));

const StyledTypography = styled(Typography)(({ theme, isVerified }) => ({
  color: isVerified ? theme.palette.success.main : theme.palette.error.main,
}));
function VerificationDialog({ open, handleClose, insureeData }) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [guardianChfd, setIsGuardianChfd] = useState(null);
  const [rightsEnable, setRightsEnable] = useState(false);
  const [matchingInsuree, setMatchingInsuree] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fosaDetails = useSelector((state) => state?.fosaReducer);
  const hfid = useSelector(
    (state) =>
      state?.profileReducer?.currentUserResponseData?.i_user?.health_facility_id
  );
  useEffect(() => {
    const insureeId = insureeData?.camuNumber
      ? insureeData?.camuNumber
      : insureeData?.chfId;
    if (insureeId) {
      dispatch(fetchVerificationHistory(insureeId));
      dispatch(fetchPoliciesByInsuree(insureeId));
      dispatch(fetchLatestActiveInsureePolicy(insureeId));
    }
    if (insureeData?.age < 8) {
      dispatch(fetchGuardian(insureeId));
    }
  }, [insureeData?.chfId]);

  useEffect(() => {
    const contentType = "pdf";
    if (fosaDetails?.careSheetData) {
      displayPrintWindow(fosaDetails?.careSheetData?.data, contentType);
    }
  }, [fosaDetails?.careSheetData]);

  const handleRowsPerPageChange = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleNavigation = (direction) => {
    console.log("Navigating", direction);
  };

  const headers = () => {
    var h = [
      t("verificationNo"),
      t("verifiedBy"),
      t("fosaName"),
      t("createdDate"),
      t("createdTime"),
      t("verificationStatus"),
      t("Action"),
    ];

    return h;
  };

  const displayPrintWindow = (base64Data, contentType) => {
    const printWindow = window.open(
      "",
      "Print Window",
      "width=600, height=400"
    );
    printWindow.document.open();

    if (contentType === "pdf") {
      // printWindow.print(`<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`);
      printWindow.document.write(
        `<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`
      );
    } else {
      printWindow.document.write(
        `<img src="data:image/png;base64,${base64Data}" />`
      );
    }

    printWindow.document.close();
    // printWindow.print();
  };

  const printRowCamuSheet = async (edited) => {
    const data = await dispatch(printCareSheet(edited));
    const base64Data = data?.payload?.data?.camuCareSheet?.data;

    // const contentType = "pdf";
    // if (base64Data) {
    //   displayPrintWindow(base64Data, contentType);
    // }
  };

  const verificationHistoryData = fosaDetails?.verificationHistoryData;

  const itemFormatters = () => {
    let f = [
      (verificationHistory) => verificationHistory.verificationCode,
      (verificationHistory) =>
        verificationHistory?.userHf &&
        `${
          !!verificationHistory?.userHf?.verifiedBy
            ? verificationHistory?.userHf?.verifiedBy?.otherNames
            : ""
        }-${
          !!verificationHistory?.userHf?.verifiedBy
            ? verificationHistory?.userHf?.verifiedBy?.chfId
            : ""
        }`,
      (verificationHistory) =>
        verificationHistory?.userHf &&
        verificationHistory?.userHf?.healthFacility &&
        verificationHistory?.userHf?.healthFacility?.name,
      (verificationHistory) =>
        formatDateFromISO(
          //   this.props.modulesManager,
          //   this.props.intl,
          verificationHistory.createdTime
        ),
      (verificationHistory) =>
        moment(verificationHistory.createdTime).format("HH:mm:ss"),
      (verificationHistory) => (
        <StyledTypography isVerified={verificationHistory.isVerified}>
          {!!verificationHistory.isVerified ? t("success") : t("failed")}
        </StyledTypography>
      ),
    ];

    f.push((verificationHistory) =>
      !!verificationHistory.isVerified ? (
        <IconButton onClick={(e) => printRowCamuSheet(verificationHistory)}>
          <LocalPrintshopOutlinedIcon color="primary" />
        </IconButton>
      ) : null
    );

    return f;
  };

  const policiesData = fosaDetails?.policies;

  const policiesHeaders = () => {
    var h = [
      t("productCode"),
      t("productName"),
      t("expiryDate"),
      t("Status"),
      t("deduction"),
      t("hospitalDeduction"),
      t("nonHospitalDeduction"),
      t("ceiling"),
      t("hospitalCeiling"),
      t("nonHospitalCeiling"),
    ];

    return h;
  };

  const policiesItemFormatters = () => {
    let f = [
      (i) => i.productCode,
      (i) => i.productName,
      (i) => formatDateFromISO(i.expiryDate),
      (i) => i.status,
      // formatMessage(this.props.intl, "policy", `policies.status.${i.status}`),
      (i) => i.ded,
      (i) => i.dedInPatient,
      (i) => i.dedOutPatient,
      (i) => i.ceiling,
      (i) => i.ceilingInPatient,
      (i) => i.ceilingOutPatient,
    ];
    // if (this.showBalance) {
    //   f.push((i) => i.balance);
    // }
    return f;
  };
  let ws;
  useEffect(() => {
    if (!!ws && !rightsEnable) {
      ws.close();
      setRightsEnable(false);
    }
  }, [rightsEnable]);
  const handleVerification = async () => {
    console.log("=====> handleVerification")
    const hfVerificationApi = await dispatch(
      insureeVerificationHf(insureeData?.id, hfid, guardianChfd)
    );
    const hfverifiedData = hfVerificationApi?.insureeVerificationHf;

    console.log("=====> hfVerificationApi", hfVerificationApi?.insureeVerificationHf)

    if (!rightsEnable && !!hfVerificationApi?.insureeVerificationHf?.success) {
      const host = window.location.host;
      ws = new WebSocket(
        `wss://${
          host.includes("localhost") ? "dev-camu.devopsdemo.live" : host
        }/api/insuree/matching-results/${insureeData?.chfId}/${decodeId(
          !!hfverifiedData?.data.id ? hfverifiedData?.data.id : ""
        )}`
      );

      ws.onopen = () => {
        // on connecting, do nothing but log it to the console
        console.log("connectedweb");
      };

      ws.onmessage = (evt) => {
        // listen to data sent from the websocket server
        const message = JSON.parse(evt.data);
        setMatchingInsuree(message);
        console.log("message", message);
      };

      ws.onclose = () => {
        console.log("disconnected");
        // automatically try to reconnect on connection loss
      };

      window.open(
        `${process.env.REACT_APP_ABIS_VERIFICATION_URL}?externalId=${
          !!guardianChfd ? guardianChfd : insureeData?.chfId
        }`,
        "_blank"
      );
      setRightsEnable(true);
    }
  };

  const handleGuardianPickerChange = (e) => {
    setIsGuardianChfd(e.target.value);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="flex-end">
          <IconButton
            color="inherit"
            onClick={() => {
              setMatchingInsuree({});
              setRightsEnable(false);
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box display="flex" alignItems="center">
          <Avatar
            alt="User Avatar"
            src={insureeData?.photoUrl}
            sx={{ width: 100, height: 100 }}
          />
          <Box ml={2}>
            <Typography variant="h6">
              {insureeData?.camuNumber
                ? insureeData?.camuNumber
                : insureeData?.chfId}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {insureeData?.otherNames}
              {insureeData?.lastName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {insureeData?.dob}({insureeData?.age} {t("Years")})
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {insureeData?.gender?.code == "M" ? t("Male") : t("Female")}
            </Typography>
          </Box>
          <StyledRightsTypography>
            {!!fosaDetails?.policyValidData && (
              <>
                {fosaDetails?.policyValidData?.insuree?.status == "ACTIVE" ? (
                  <Typography color="primary">
                    <CheckCircleIcon color="primary" />
                    {t("rightsEnabled")}
                  </Typography>
                ) : (
                  <Typography color="red">
                    <CancelIcon color="red" />
                    {t("rightsDisabled")}
                  </Typography>
                )}
              </>
            )}
          </StyledRightsTypography>
        </Box>
      </DialogTitle>
      <DialogActions sx={{ marginTop: "-3rem" }}>
        {insureeData?.age < 8 && !!fosaDetails?.policyValidData && (
          <Dropdown
            onChange={(e) => {
              handleGuardianPickerChange(e);
            }}
            options={fosaDetails?.policyValidData || []}
            value={guardianChfd}
          />
        )}
        <Button
          variant="contained"
          color="success"
          onClick={() => handleVerification()}
          width={4}
          disabled={
            fosaDetails?.policyValidData?.insuree?.status == "ACTIVE" &&
            !rightsEnable
              ? false
              : true
          }
        >
          {t("VerifyFingerprints")}
        </Button>
      </DialogActions>
      <DialogContent dividers>
        <Box mb={2}>
          <StyledPaper>
            <StyledPaperHeader container alignItems="center" direction="row">
              <Grid item alignItems="center">
                <Typography variant="h6">{t("policies")}</Typography>
              </Grid>
            </StyledPaperHeader>
            <TableN
              headers={policiesHeaders()}
              itemFormatters={policiesItemFormatters()}
              items={policiesData ? policiesData : []}
              withSelection="single"
              withPagination
              rowsPerPageOptions={[10, 50, 100]}
              defaultPageSize={5}
              page={page}
              pageSize={pageSize}
              // count={pageInfo}
              onChangePage={(event, newPage) => {
                setPage(newPage);
                handleNavigation(newPage > page ? "forward" : "backward");
              }}
              onChangeRowsPerPage={handleRowsPerPageChange}
            />
          </StyledPaper>
        </Box>
        <Box>
          <StyledPaper>
            <StyledPaperHeader container alignItems="center" direction="row">
              <Grid item alignItems="center">
                <Typography variant="h6">{t("verificationHistory")}</Typography>
              </Grid>
            </StyledPaperHeader>
            <TableN
              headers={headers()}
              itemFormatters={itemFormatters()}
              items={verificationHistoryData}
              withSelection="single"
              withPagination
              rowsPerPageOptions={[10, 50, 100]}
              defaultPageSize={5}
              page={page}
              pageSize={pageSize}
              count={0}
              onChangePage={(event, newPage) => {
                setPage(newPage);
                handleNavigation(newPage > page ? "forward" : "backward");
              }}
              onChangeRowsPerPage={handleRowsPerPageChange}
            />
          </StyledPaper>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default VerificationDialog;
